// TODO: Delete this enum once the migration is done and FG_Filemanager.jsx deleted
export enum FilesTableEnum {
  Personal = 'personal',
  Received = 'received',
  Shared = 'shared',
  Favorites = 'favorites',
  Hidden = 'hidden',
  Trash = 'trash',
}
